<template>
  <div>
    <!-- pc -->
    <div class="special_4">
      <div class="resume">
        <div class="pic fl">
          <a :href="imgLink" target="_blank"
            ><img :src="img" alt="" style="border-style: none"
          /></a>
        </div>
        <div class="content fr">
          <div class="row1">
            <strong class="fl"
              ><a :href="imgLink" v-html="leaderName" target="_blank"></a
            ></strong>
            <p>
              {{ leaderJob }}
            </p>
          </div>
          <div class="row2">
            <span v-html="leaderIntro">
              <!-- {{ cLeaderIntro }} -->
            </span>
          </div>
          <div class="row2">
            <span>工作分工：</span>
            <span v-html="fgfw">
              <!-- {{ cLeaderIntro }} -->
            </span>
          </div>
        </div>
      </div>
      <!-- 暂无数据 -->
      <!-- <div class="tagArea">
      <div class="tags">
        <div
          class="aTag fl"
          :class="{ active: isActive == 'tag1' }"
          @click="tagClick"
          id="tag1"
          v-html="cTagNames[0]"
        ></div>
        <div
          class="aTag fl"
          :class="{ active: isActive == 'tag2' }"
          @click="tagClick"
          id="tag2"
          v-html="cTagNames[1]"
        ></div>
        <div
          class="aTag fl"
          :class="{ active: isActive == 'tag3' }"
          @click="tagClick"
          id="tag3"
          v-html="cTagNames[2]"
        ></div>
      </div>
      <div class="clear" style="clear: both"></div>
      <div class="cards">
        <ul class="card1" v-show="isActive == 'tag1'">
          <li v-for="(item, index) in 5" :key="index">
            <i> </i>
            <a :href="cTagInfos1.info1.link" v-html="cTagInfos1.info1.title">
            </a>
            <span class="date fr" v-html="cTagInfos1.info1.date"></span>
          </li>
        </ul>
        <ul class="card2" v-show="isActive == 'tag2'">
          <li v-for="(item, index) in 5" :key="index">
            <i> </i>
            <a
              :href="cTagInfos2.info1.link"
              v-html="cTagInfos2.info1.title"
            ></a>
            <span class="date fr" v-html="cTagInfos2.info1.date"></span>
          </li>
        </ul>
        <ul class="card3" v-show="isActive == 'tag3'">
          <li v-for="(item, index) in 5" :key="index">
            <i> </i>
            <a
              :href="cTagInfos3.info1.link"
              v-html="cTagInfos3.info1.title"
            ></a>
            <span class="date fr" v-html="cTagInfos3.info1.date"></span>
          </li>
        </ul>
      </div>
    </div> -->
    </div>
    <!-- 移动端 -->
    <div class="mobile">
      <div class="resume">
        <div class="pic fl">
          <a :href="imgLink" target="_blank"
            ><img :src="img" alt="" style="border-style: none"
          /></a>
        </div>
        <div class="content fr">
          <div class="row1">
            <strong class="fl"
              ><a :href="imgLink" v-html="leaderName" target="_blank"></a
            ></strong>
            <p>
              {{ leaderJob }}
            </p>
          </div>
          <div class="row2">
            <span v-html="leaderIntro">
              <!-- {{ cLeaderIntro }} -->
            </span>
          </div>
          <div class="row2">
            <span>工作分工：</span>
            <span v-html="fgfw">
              <!-- {{ cLeaderIntro }} -->
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-special-leader",
  components: {},
  props: {
    cLeaderInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    cTagNames: {
      type: Array,
      default: function () {
        return ["最新消息", "会议座谈", "考察调研"];
      },
    },
    cTagInfos1: {
      type: Object,
      default: function () {
        return {
          info1: {
            link: "###",
            title: "推进旅游企业扩大复工复业有关事项",
            date: "2020-08-01",
          },
        };
      },
    },
    cTagInfos2: {
      type: Object,
      default: function () {
        return {
          info1: {
            link: "###",
            title: "内蒙古自治区政协",
            date: "2020-08-02",
          },
        };
      },
    },
    cTagInfos3: {
      type: Object,
      default: function () {
        return {
          info1: {
            link: "###",
            title: "包头市国资委",
            date: "2020-08-03",
          },
        };
      },
    },
  },
  data() {
    return {
      isActive: "tag1",
    };
  },
  watch: {},
  computed: {
    img() {
      return this.cLeaderInfo.ldzp;
      // return this.cLeaderInfo.docpuburl
      //   .substring(0, this.cLeaderInfo.docpuburl.lastIndexOf("/"))
      //   .concat("/")
      //   .concat(
      //     this.cLeaderInfo.ldzp.substring(0, this.cLeaderInfo.ldzp.indexOf("|"))
      //   );
    },
    imgLink() {
      return this.cLeaderInfo.docpuburl;
    },
    leaderName() {
      return this.cLeaderInfo.ldr_doctitle;
    },
    leaderJob() {
      return this.cLeaderInfo.zw;
    },
    leaderIntro() {
      return this.cLeaderInfo.ldr_doccontent;
    },
    fgfw() {
      return this.cLeaderInfo.fgfw;
    },
  },
  methods: {
    tagClick() {
      this.isActive = event.target.id;
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
@media screen and (min-width: 751px) {
  .mobile {
    display: none;
  }
  .special_4 {
    display: block;
    width: 823px;
    margin-bottom: 40px;
    // height: 410px;
    .resume {
      width: 823px;
      height: 200px;
      .pic {
        width: 130px;
        height: 180px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        width: 650px;
        height: 180px;
        font-size: 14px;
        line-height: 24px;
        overflow: hidden;
        .row1 {
          strong {
            display: inline-block;
            // height: 48px;
            font-size: 16px;
            margin-right: 10px;
            a {
              color: #333;
            }
          }
          p {
            margin: 0;
            padding: 0;
          }
        }
        .row2 {
          width: 650px;
          height: 68px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          margin-top: 10px;
        }
      }
    }
    .tagArea {
      width: 823px;
      height: 165px;
      margin-top: 15px;
      .tags {
        width: 823px;
        height: 30px;
        padding-bottom: 5px;
        border-bottom: 1px solid rgb(230, 230, 230);
        .aTag {
          font-size: 16px;
          margin: 0 10px;
          font-weight: bold;
          cursor: pointer;
          padding: 3px 10px 3px 10px;
        }
        .active {
          color: #ffffff;
          background-color: rgb(1, 82, 147);
          // color: rgb(1, 82, 147);
          // border-bottom: 1px solid rgb(1, 82, 147);
        }
      }
      .cards {
        width: 823px;
        ul {
          width: 823px;
          margin: 0;
          padding: 0;
          li {
            width: 823px;
            height: 28px;
            font-size: 14px;
            line-height: 24px;
            i {
              display: inline-block;
              width: 15px;
              height: 15px;
              background-image: url(../../assets/img/pointer.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              top: 10%;
              position: relative;
            }
            a {
              color: black;

              // text-decoration: underline;
              // color: #0042a2;
            }
            a:hover {
              color: rgb(1, 82, 147);
            }
            span {
              width: 80px;
              margin-left: 10px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 751px) {
  @w: 7.5vw;

  .special_4 {
    display: none;
  }
  .mobile {
    display: block;
    width: 710 / @w;
    margin: 0 auto;
    padding-bottom: 20 / @w;
    border-bottom: 1 / @w solid rgb(230, 230, 230);
    margin-bottom: 20 / @w;
    // height: 410px;
    .resume {
      width: 700 / @w;
      height: 280 / @w;
      padding-top: 30 / @w;
      background-color: rgb(247, 248, 253);
      .pic {
        width: 177 / @w;
        height: 251 / @w;
        margin-left: 30 / @w;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        width: 452 / @w;
        height: 251 / @w;
        // font-size: 24 / @w;
        line-height: 26 / @w;
        overflow: hidden;
        .row1 {
          line-height: 40 / @w;
          strong {
            display: inline-block;
            // height: 48px;
            font-size: 30 / @w;
            margin-right: 10 / @w;
            a {
              color: #333;
            }
          }
          p {
            margin: 0;
            padding: 0;
          }
        }
        .row2 {
          line-height: 45 / @w;
          width: 452 / @w;
          height: 80 / @w;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>